import  _ from 'lodash';
import { FCCalendar } from '@algomusinc/domain';


// for sync button
export const setSyncButtonClass = (status: string): string => {
  let result = '';
  if (status == 'InProgress') result = 'in-progress';
  if (status == 'Queued') result = 'queued';
  if (status == 'Failed') result = 'failed';
  return result;
};


export class TreeControlParams {
  dataList: any = [];
  mappedValueList: any = [];
  disableValueList: any = [];
  isAllChecked: boolean = false;
  isAllDisabled: boolean = false;
};

export const CreateForecastAccountTree = ({
  dataList = [],
  mappedValueList = [],
  disableValueList = [],
  isAllChecked = false,
  isAllDisabled = false
}: TreeControlParams) => {
  const channels = _.uniqBy(dataList, (a: any) => a.channel);

  let treeList: any = [];
  channels.forEach((channel: any) => {
    let channelObject:any = {
      channels: channel.channel,
      name: channel.channel,
      channel: channel.channel,
      retailerKey: channel.retailerKey,
      children: [],
      isChannel: true,
      isDelete: true,
    };
    const regions = _.uniqBy(_.filter(dataList, (a: any) =>
      a.channel === channel.channel
    ), (b: any) => b.region);
    regions.forEach((region: any) => {
      let regionObject: any = {
        regionName: region.region,
        name: region.region,
        region: region.region,
        channel: channel.channel,
        retailerKey: region.retailerKey,
        children: [],
        isCountry: true,
        isDelete: true,
      };
      const countries = _.uniqBy(_.filter(dataList, (a: any) => a.channel === channel.channel && a.region === region.region), (b: any) => b.country);
      countries.forEach((country: any) => {
        let countryObj: any = {
          countries: country.country,
          name: country.country,
          country: country.country,
          region: region.region,
          channel: channel.channel,
          retailerKey: country.retailerKey,
          children: [],
          isRegion: true,
          isDelete: true,
        };

        let retailers = _.uniqBy(_.filter(dataList, (a: any) =>
          a.country === country.country &&
          a.region === region.region &&
          a.channel === channel.channel), (b: any) => b.retailer);
        retailers = retailers.map((row: any) => ({
          name: row.retailer,
          isProduct: true,
          ...row,
        }));
        countryObj.children = retailers;
        if (regionObject) {
          regionObject.children.push(countryObj);
        }
      });
      if (regionObject) {
        channelObject.children.push(regionObject);
      }
    });
    treeList.push(channelObject);
  });
  const tree: any = [];
  treeList.forEach((channel: any) => {
    let channelObject = new Object({
      text: channel.name,
      collapsed: true,
      value: channel.channel,
      checked: isAllChecked || mappedValueList.includes(channel.retailerKey),
      disabled: isAllDisabled,
      children: channel.children.map((region: any) => {
        return new Object({
          text: region.name,
          collapsed: true,
          value: region.region,
          checked: isAllChecked || mappedValueList.includes(region.retailerKey),
          disabled: isAllDisabled,
          children: region.children.map((country: any) => {
            return new Object({
              text: country.name,
              collapsed: true,
              value: country.country,
              checked: isAllChecked || mappedValueList.includes(country.retailerKey),
              disabled: isAllDisabled,
              children: country.children.map((retailer: any) => {
                return new Object({
                  text: retailer.name,
                  collapsed: true,
                  value: retailer.retailerKey,
                  checked: isAllChecked || mappedValueList.includes(retailer.retailerKey),
                  disabled: isAllDisabled || disableValueList.includes(retailer.retailerKey),
                });
              }),
            });
          }),
        });
      }),
    });
    tree.push(channelObject);
  });
  return tree;
};

export const CreateForecastItemTree = ({
  dataList = [],
  mappedValueList = [],
  disableValueList = [],
  isAllChecked = false,
  isAllDisabled = false
}: TreeControlParams) => {

  const brands = _.uniqBy(dataList, (a: any) => a.brand);

  let treeList: any = [];
  brands.forEach((brand: any) => {
    let brandsObject: any = {
      brandsName: brand.brand,
      name: brand.brand,
      brand: brand.brand,
      itemKey: brand.itemKey,
      children: [],
      isBrand: true,
    };

    const productGroups = _.uniqBy(_.filter(dataList, (a: any) =>
      a.brand === brand.brand
    ), (b: any) => b.productGroup);

    productGroups.forEach((productGroup: any) => {
      let productGroupObject: any = {
        productGroupName: productGroup.productGroup,
        name: productGroup.productGroup,
        productGroup: productGroup.productGroup,
        brand: brand.brand,
        itemKey: productGroup.itemKey,
        children: [],
        isProductFamily: true,
      };

      const parentProducts = _.uniqBy(_.filter(dataList, (a: any) => a.brand === brand.brand && a.productGroup === productGroup.productGroup), (b: any) => b.parentProduct);

      parentProducts.forEach((parentProduct: any) => {
        let parentProductObject: any = {
          parentProductName: parentProduct.parentProduct,
          name: parentProduct.parentProduct,
          parentProduct: parentProduct.parentProduct,
          productGroup: productGroup.productGroup,
          brand: brand.brand,
          itemKey: parentProduct.itemKey,
          children: [],
          isProductGroup: true,
        };

        const productDescriptions = _.uniqBy(_.filter(dataList, (a: any) =>
          a.brand === brand.brand
          && a.productGroup === productGroup.productGroup
          && a.parentProduct === parentProduct.parentProduct
        ), (b: any) => b.productDescription);

        productDescriptions.forEach((productDescription: any) => {

          let productDescriptionObject: any = {
            productDescriptionName: productDescription.productDescription,
            name: productDescription.productDescription,
            itemKey: productDescription.itemKey,
            productDescription: productDescription.productDescription,
            parentProduct: parentProduct.parentProduct,
            productGroup: productGroup.productGroup,
            brand: brand.brand,
            isParentProduct: true,
          };

          if (productDescriptionObject.productDescription) {
            parentProductObject.children.push(productDescriptionObject);
          }
        });
        if (parentProductObject.parentProduct) {
          productGroupObject.children.push(parentProductObject);
        }
      });
      if (productGroupObject.productGroup) {
        brandsObject.children.push(productGroupObject);
      }
    });
    treeList.push(brandsObject);
  });
  const tree: any = [];
  treeList.forEach((brand: any) => {
    let brandObject = new Object({
      text: brand.name,
      collapsed: true,
      checked: isAllChecked || mappedValueList.includes(brand.itemKey),
      value: brand.brand,
      children: brand.children.map((productGroup: any) => {
        return new Object({
          text: productGroup.name,
          collapsed: true,
          checked: isAllChecked || mappedValueList.includes(productGroup.itemKey),
          value: productGroup.productGroup,
          children: productGroup.children.map((parentProduct: any) => {
            return new Object({
              text: parentProduct.name,
              collapsed: true,
              checked: isAllChecked || mappedValueList.includes(parentProduct.itemKey),
              value: parentProduct.parentProduct,
              children: parentProduct.children.map((productDescription: any) => {
                return new Object({
                  text: productDescription.name,
                  collapsed: true,
                  value: productDescription.itemKey,
                  checked: isAllChecked || mappedValueList.includes(productDescription.itemKey),
                  disabled: isAllDisabled || disableValueList.includes(productDescription.itemKey),
                });
              }),
            });
          }),
          // });
          // }),
        });
      }),
    });
    tree.push(brandObject);
  });
  return tree;
}
export const CreateForecastItemTree2 = ({
  dataList = [],
  mappedValueList = [],
  disableValueList = [],
  isAllChecked = false,
  isAllDisabled = false
}: TreeControlParams) => {
  const brands = _.uniqBy(dataList, (a: any) => a.brand);

  let treeList: any = [];
  brands.forEach((brand: any) => {
    let brandsObject:any = {
      brandsName: brand.brand,
      name: brand.brand,
      brand: brand.brand,
      itemKey: brand.itemKey,
      children: [],
      isBrand: true,
    };

    const productGroups = _.uniqBy(_.filter(dataList, (a: any) =>
      a.brand === brand.brand
    ), (b: any) => b.productGroup);

    productGroups.forEach((productGroup: any) => {
      let productGroupObject: any = {
        productGroupName: productGroup.productGroup,
        name: productGroup.productGroup,
        productGroup: productGroup.productGroup,
        brand: brand.brand,
        itemKey: productGroup.itemKey,
        children: [],
        isProductFamily: true,
      };

      const parentProducts = _.uniqBy(_.filter(dataList, (a: any) => a.brand === brand.brand && a.productGroup === productGroup.productGroup), (b: any) => b.parentProduct);

      parentProducts.forEach((parentProduct: any) => {
        let parentProductObject: any = {
          parentProductName: parentProduct.parentProduct,
          name: parentProduct.parentProduct,
          parentProduct: parentProduct.parentProduct,
          productGroup: productGroup.productGroup,
          brand: brand.brand,
          itemKey: parentProduct.itemKey,
          children: [],
          isProductGroup: true,
        };
        const productDescriptions = _.uniqBy(_.filter(dataList, (a: any) =>
          a.brand === brand.brand
          && a.productGroup === productGroup.productGroup
          && a.parentProduct === parentProduct.parentProduct
        ), (b: any) => b.productDescription);

        productDescriptions.forEach((productDescription: any) => {

          let productDescriptionObject: any = {
            productDescriptionName: productDescription.productDescription,
            name: productDescription.productDescription,
            itemKey: productDescription.itemKey,
            productDescription: productDescription.productDescription,
            parentProduct: parentProduct.parentProduct,
            productGroup: productGroup.productGroup,
            brand: brand.brand,
            isParentProduct: true,
          };

          if (productDescriptionObject.productDescription) {
            parentProductObject.children.push(productDescriptionObject);
          }
        });
        if (parentProductObject.parentProduct) {
          productGroupObject.children.push(parentProductObject);
        }
      });
      if (productGroupObject.productGroup) {
        brandsObject.children.push(productGroupObject);
      }
    });
    treeList.push(brandsObject);
  });
  const tree: any = [];
  treeList.forEach((brand: any) => {
    let brandObject = new Object({
      text: brand.name,
      collapsed: true,
      checked: isAllChecked || mappedValueList.includes(brand.itemKey),
      disabled: isAllDisabled,
      value: brand.brand,
      children: brand.children.map((productGroup: any) => {
        return new Object({
          text: productGroup.name,
          collapsed: true,
          checked: isAllChecked || mappedValueList.includes(productGroup.itemKey),
          disabled: isAllDisabled,
          value: productGroup.productGroup,
          children: productGroup.children.map((parentProduct: any) => {
            return new Object({
              text: parentProduct.name,
              collapsed: true,
              checked: isAllChecked || mappedValueList.includes(parentProduct.itemKey),
              disabled: isAllDisabled,
              value: parentProduct.parentProduct,
              children: parentProduct.children.map((productDescription: any) => {
                return new Object({
                  text: `${productDescription.itemKey}-${productDescription.name}`,
                  collapsed: true,
                  value: productDescription.itemKey,
                  checked: isAllChecked || mappedValueList.includes(productDescription.itemKey),
                  disabled: isAllDisabled || disableValueList.includes(productDescription.itemKey),
                });
              }),
            });
          }),
          // });
          // }),
        });
      }),
    });
    tree.push(brandObject);
  });
  return tree;
}

export const CreateForecastCalendarList = (
  calendarListDropdown: any,
  timeframeList: any,
  mappedTimeFrame: any,
) => {
  calendarListDropdown = [];
  const uniqueYears: any = [
    ...new Set(timeframeList.map((item: FCCalendar) => item.reportYear)),
  ];
  uniqueYears.forEach((year: string, index: number) => {
    const yearList = timeframeList.filter((row: any) => row.reportYear === year);
    const uniqueHalfYears = [
      ...new Set(yearList.map((item: FCCalendar) => item.reportHalf)),
    ];
    const uniqueQuarters: any = [];
    const uniqueMonths: any = [];
    const uniqueWeeks: any = [];
    yearList.forEach((y: any) => {
      if (
        uniqueQuarters.findIndex(
          (x: any) => x.quater === y.quater && x.reportHalf === y.reportHalf
        ) < 0
      ) {
        uniqueQuarters.push({ quater: y.quater, reportHalf: y.reportHalf });
      }
      if (
        uniqueMonths.findIndex(
          (x: any) => x.quater === y.quater && x.reportMonth === y.reportMonth
        ) < 0
      ) {
        uniqueMonths.push({ quater: y.quater, reportMonth: y.reportMonth });
      }
      if (
        uniqueWeeks.findIndex(
          (x: any) => x.quater === y.quater && x.reportMonth === y.reportMonth && x.weekStartDate === y.weekStartDate
        ) < 0
      ) {
        uniqueWeeks.push({ quater: y.quater, reportMonth: y.reportMonth, weekStartDate: y.weekStartDate });
      }
      y.checked =
        mappedTimeFrame && mappedTimeFrame.weekNumber
          ? mappedTimeFrame.weekNumber
            .split(',')
            .find((val: any) => val === y.weekNumber.toString())
          : false;
    });
    const obj = new Object({
      text: year,
      value: year,
      checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(yearList.weekNumber),
      collapsed: true,
      children: uniqueHalfYears.map(
        (h: any) =>
          new Object({
            text: h,
            value: h,
            checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(h.weekNumber),
            collapsed: true,
            children: uniqueQuarters
              .filter((e: any) => e.reportHalf === h)
              .map(
                (q: any) =>
                  new Object({
                    text: q.quater,
                    value: q.quater,
                    checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(q.weekNumber),
                    collapsed: true,
                    children: uniqueMonths
                      .filter((el: any) => el.quater === q.quater)
                      .map((m: any) => ({
                        children: yearList
                          .filter(
                            (el: any) =>
                              el.reportMonth === m.reportMonth &&
                              el.quater === q.quater &&
                              el.reportHalf === h
                          )
                          .map(
                            (row: any) =>
                              new Object({
                                text: new Date(
                                  row.weekStartDate
                                ).toLocaleDateString(),
                                value: row.weekNumber,
                                checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(row.weekNumber),
                                collapsed: true,
                              })
                          ),
                        text: m.reportMonth,
                        checked: mappedTimeFrame.length > 0 && mappedTimeFrame.includes(m.weekNumber),
                        value: yearList
                          .filter(
                            (el: any) =>
                              el.weekNumber === m.weekNumber &&
                              el.reportMonth === m.reportMonth &&
                              el.quater === q.quater &&
                              el.reportHalf === h
                          )
                          .map((cal: any) => cal.weekNumber),
                      })),
                  })
              ),
          })
      ),
    });
    calendarListDropdown.push(obj);
  });
  return calendarListDropdown;
};


export const CreateProductHierarchyTree = (productData: any, selectedValues: any = []) => {
  let treeList = [];
  treeList = product_list_to_tree(productData);
  let tree: any = [];
  treeList.forEach((obj) => {
    let data = fromProductTreeView(obj, selectedValues);
    tree.push(data);

  });
  return tree;
};

// create nth nested object of tree view items
const fromProductTreeView = (obj: any, selectedValues: any) => {
  return new Object({
    text: obj.productHierarchyValue,
    value: obj.productHierarchyId,
    collapsed: true,
    checked: selectedValues.includes(obj.productHierarchyId),
    children: obj.children && obj.children.length && obj.children.map((el: any) => {
      return fromProductTreeView(el, selectedValues);
    })
  });
}

const product_list_to_tree = (list: any) => {
  let map: any = {};
  let node: any;
  const roots = [];

  for (let i = 0; i < list.length; i++) {
    map[list[i].productHierarchyId] = i; // initialize the map
    list[i].children = []; // initialize the children
  }
  for (let i = 0; i < list.length; i++) {
    node = list[i];
    if (node.productParentId && node.productParentId !== 0) {
      // if you have check that map[node.productParentId] exists..
      list[map[node.productParentId]].children.push(node);
      // }
    } else {
      roots.push(node);
    }
  }
  return roots;
}


export const CreateLocationHierarchyTree = (locationData: any, select: any = []) => {
  let treeList = [];
  treeList = location_list_to_tree(locationData);
  let tree: any = [];
  treeList.forEach((obj) => {
    let data = fromLocationTreeView(obj, select);
    tree.push(data);

  });
  return tree;
};

// create nth nested object of tree view items
const fromLocationTreeView = (obj: any, select: any) => {
  return new Object({
    text: obj.locationHierarchyValue,
    value: obj.locationHierarchyId,
    collapsed: true,
    checked: select.includes(obj.locationHierarchyId),
    children: obj.children && obj.children.length && obj.children.map((el: any) => {
      return fromLocationTreeView(el, select);
    })
  });
}

const location_list_to_tree = (list: any) => {
  let map: any = {};
  let node: any;
  const roots = [];

  for (let i = 0; i < list.length; i++) {
    map[list[i].locationHierarchyId] = i; // initialize the map
    list[i].children = []; // initialize the children
  }
  for (let i = 0; i < list.length; i++) {
    node = list[i];
    if (node.locationParentId && node.locationParentId !== 0) {
      // if you have check that map[node.locationParentId] exists..
      list[map[node.locationParentId]].children.push(node);
      // }
    } else {
      roots.push(node);
    }
  }
  return roots;
}
